<script setup lang="ts">

</script>

<template>
  <div class="marquee relative">
    <div class="marquee__inner text-marquee">
      <div class="flex align-center" v-for="i in 18" :key="i">
        <span>gaming operator</span>
        <div class="rec"></div>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
.marquee {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.20);
  box-shadow: 0px 0px 32.2px 0px rgba(255, 255, 255, 0.15);
  padding: clamp(25px, 1.736vw, 125px) 0;
  z-index: 3;
  &__inner {
    display: flex;
    gap: clamp(19px, 1.319vw, 100px);
    animation: marquee 50s linear infinite;
    & > div {
      gap: clamp(19px, 1.319vw, 100px);
    }
    span {
      display: inline-block;
      color: #FFF;
      font-size: clamp(31px, 2.153vw, 155px);
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .rec {
      border-radius: 2px;
      border: 1px solid #FFF;
      background: rgba(255, 255, 255, 0.30);
      width: clamp(12px, 0.833vw, 60px);
      height: clamp(12px, 0.833vw, 60px);
    }
  }
}
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

@media (max-width: 768px) {
  .marquee {
    padding: 32px 0;
  }
  .marquee__inner {
    span {
      font-size: 20px;
    }
  }
}
</style>